const bootstrap = import("./bootstrap");
export default bootstrap;